import { create } from "zustand";

export interface AuthUser {
	id: number;
	login: string;
	displayName: string;
	role: "admin" | "user";
}

interface AuthState {
	user: AuthUser | null;
	isAuthenticated: boolean;
	mustChangePassword: boolean;
	setUser: (user: AuthUser, mustChangePassword: boolean) => void;
	clearUser: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
	user: null,
	isAuthenticated: false,
	mustChangePassword: false,

	setUser: (user, mustChangePassword) => set({ user, isAuthenticated: true, mustChangePassword }),

	clearUser: () => set({ user: null, isAuthenticated: false, mustChangePassword: false }),
}));

export function useIsAdmin(): boolean {
	return useAuthStore((state) => state.user?.role === "admin");
}
